/**
 * accentColors — the 4-color accent vocabulary used across the Home tab
 * (rank badges, stat-strip icons, card ring gauges, the modal's active
 * left-rail row). Centralized so every consumer resolves the same key the
 * same way instead of re-deriving color-mix() tints per component.
 *
 * Insight payloads (mock or real) reference one of these keys by name
 * (e.g. `accent: 'purple'`); an unknown key falls back to 'blue'.
 */
export const ACCENTS = {
  blue: {
    text: 'var(--accent-text-blue)',
    bg: 'color-mix(in srgb, var(--color-semantic-blue) var(--mix-bg), var(--color-blue-900))',
    border: 'color-mix(in srgb, var(--color-semantic-blue) var(--mix-border), transparent)',
  },
  purple: {
    text: 'var(--color-purple-400)',
    bg: 'color-mix(in srgb, var(--color-purple-500) var(--mix-bg), var(--color-blue-900))',
    border: 'color-mix(in srgb, var(--color-purple-500) var(--mix-border), transparent)',
  },
  green: {
    text: 'var(--accent-text-green)',
    bg: 'color-mix(in srgb, var(--color-semantic-green) var(--mix-bg), var(--color-blue-900))',
    border: 'color-mix(in srgb, var(--color-semantic-green) var(--mix-border), transparent)',
  },
  orange: {
    text: 'var(--color-orange-400)',
    bg: 'color-mix(in srgb, var(--color-orange-500) var(--mix-bg), var(--color-blue-900))',
    border: 'color-mix(in srgb, var(--color-orange-500) var(--mix-border), transparent)',
  },
}

export function resolveAccent(key) {
  return ACCENTS[key] ?? ACCENTS.blue
}

/**
 * BAND_COLORS — the bad→good ramp a meta band (confidence, evidence strength,
 * and later a bottleneck severity) is painted with. Same indirection as ACCENTS:
 * the backend ships a color KEY per value (polarity is per-kind config), and the
 * frontend owns what each key renders as. An absent/unknown key returns null via
 * bandColor() so the caller falls back to the card accent.
 */
export const BAND_COLORS = {
  red: 'var(--color-semantic-red)',
  orange: 'var(--color-orange-400)',
  yellow: 'var(--color-semantic-yellow)',
  green: 'var(--color-semantic-green)',
}

export function bandColor(key) {
  return BAND_COLORS[key] ?? null
}
